import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {fade} from "../models/fade";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class FadeService {

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/fade/getall');
  }

  public getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/fade/getbyidproyecto', params);
  }

  public new(fade: fade) {
    return this.http.post('/fade/new', fade);
  }

  public sendAllFades() {
    return this.http.post('/fade/sendallfades', "").subscribe(result => {
      console.log(result);
    });
  }

  public delete(id: string) {
    return this.http.delete('/fade/delete/' + id);
  }

  public update(fade: fade) {
    return this.http.post('/fade/update', fade);
  }

}
